import {
  Outlet,
  createFileRoute,
  retainSearchParams,
} from "@tanstack/react-router";

import { ProjectPageProvider } from "@/features/project/components/pages/project-page-context";
import {
  holdingProjectSearchSchema,
  loadHoldingProject,
} from "@/features/project/lib/holding-project-route";

export const Route = createFileRoute(
  "/_protected/corporate-finance/projects/$id",
)({
  component: CorporateFinanceProjectRoute,
  validateSearch: holdingProjectSearchSchema,
  search: {
    // every navigation inside the project subtree keeps the selected entity
    // without call sites having to thread it; explicit values (incl. an
    // explicit undefined) still win
    middlewares: [retainSearchParams(["entityProjectId"])],
  },
  beforeLoad: (args) => loadHoldingProject(args),
});

function CorporateFinanceProjectRoute() {
  const { id } = Route.useParams();

  return (
    <ProjectPageProvider value={{ module: "corporate-finance", projectId: id }}>
      <Outlet />
    </ProjectPageProvider>
  );
}
